import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { HOME_PATH } from "../util/constants";

const LandingPage = () => {
  const [redirectURI, setRedirectURI] = useState(null);

  useEffect(() => {
    const originalURI = sessionStorage.getItem('originalURI');
    if (originalURI) {
      setRedirectURI(originalURI);
      sessionStorage.removeItem('originalURI');
    } else {
      setRedirectURI(HOME_PATH);
    }
  }, []);

  return redirectURI && <Redirect to={redirectURI} />;
};

export default LandingPage;
